import * as React from 'react';

import { useImmerReducer } from 'use-immer';

import { assertUnreachable } from '../../../../util/assertUnreachable';

export interface QuizToMerge {
  quizName: string;
  quizId: string;
}

export interface OnMergeQuiz {
  ({
    quizName,
    quizOrder,
  }: {
    quizName: string;
    quizOrder: string[];
  }): Promise<any>;
}

interface MergeQuizDialogState {
  isOpen: boolean;
  quizzesToMerge: QuizToMerge[];
  onMergeQuiz: OnMergeQuiz;
}

function mergeQuizDialogReducer(
  draft: MergeQuizDialogState,
  action: MergeQuizDialogAction
) {
  switch (action.type) {
    case 'OPEN': {
      const { quizzesToMerge, onMergeQuiz } = action.payload;
      draft.isOpen = true;
      draft.quizzesToMerge = quizzesToMerge;
      draft.onMergeQuiz = onMergeQuiz;
      break;
    }
    case 'CLOSE': {
      draft.isOpen = false;
      draft.quizzesToMerge = [];
      draft.onMergeQuiz = null;
      break;
    }
    default: {
      assertUnreachable(action);
    }
  }
}

type MergeQuizDialogAction =
  | { type: 'CLOSE' }
  | {
      type: 'OPEN';
      payload: {
        quizzesToMerge: QuizToMerge[];
        onMergeQuiz: OnMergeQuiz;
      };
    };

export type DispatchMergeQuizDialogAction =
  React.Dispatch<MergeQuizDialogAction>;

export function useMergeQuizDialog() {
  return useImmerReducer(mergeQuizDialogReducer, {
    isOpen: false,
    quizzesToMerge: [],
    onMergeQuiz: null,
  });
}
